"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shallow_equal_object_1 = require("shallow-equal-object");
/**
 * Value object definition.
 * props is readonly by design.
 */
var ValueObject = /** @class */ (function () {
    function ValueObject(props) {
        this.props = Object.freeze(props);
    }
    /**
     * Check equality by shallow equals of properties.
     * It can be override.
     */
    ValueObject.prototype.equals = function (object) {
        if (object === null || object === undefined) {
            return false;
        }
        if (object.props === undefined) {
            return false;
        }
        return shallow_equal_object_1.shallowEqual(this.props, object.props);
    };
    return ValueObject;
}());
exports.ValueObject = ValueObject;
//# sourceMappingURL=ValueObject.js.map